<template>
  <div>
    <!-- Mientras carga, o si el turno no está autorizado, no se muestra el formulario. -->
    <div v-if="!mostrarDetalleFicha" class="card card-custom card-sticky mb-5">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">
            <span class="label label-xl label-dot label-primary mr-2"></span>
            Turno 1 - Mesa
            <small v-if="ui.estaCargandoDatos">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{
              auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="cargar()">
            <i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin' : '']"></i>
          </a>
        </div>
      </div>
    </div>

    <div v-if="mostrarDetalleFicha" class="card card-custom card-sticky mb-5">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
          <span class="label label-xl label-dot label-primary mr-2"></span>
          Turno 1 - Mesa
          <small v-if="auth.fechaInicioTurno">{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
        </h3>
      </div>
      <div class="card-toolbar">
        <span class="label label-lg label-inline mr-3" :class="porcentajeAvance >= 100 ? 'label-light-success' : 'label-light-warning'"
              v-b-tooltip.hover.top title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
          {{ Number(porcentajeAvance || 0).toFixed(0) }}% completado
        </span>
        <span v-if="finalizado" class="label label-lg label-inline label-success mr-3">Finalizado</span>
        <button v-if="finalizado && puedeReanudarTurno" type="button" class="btn btn-sm btn-warning font-weight-bold mr-2"
                :disabled="ui.estaGuardando" @click.prevent="reabrir()">Reabrir turno</button>
        <a v-if="!finalizado" href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" :disabled="ui.estaGuardando || soloLectura"
           @click.prevent="guardar(false)">
          <i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i>
          Guardar cambios
        </a>
        <a href="#" class="btn btn-icon btn-sm btn-light-primary"
           @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
          <i :class="expandirContenido ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
        </a>
      </div>
    </div>

    <!-- Sección 1 siempre visible: identificación y asistencia antes del cuestionario. -->
    <div class="card-body border-bottom px-3 px-md-9 py-4 py-md-6 bg-white">
      <h5 class="font-weight-bold text-dark mb-4">SECCIÓN 1 - IDENTIFICACIÓN</h5>

      <div class="form-group row">
        <div class="col-12 col-md-4">
          <label class="mb-1">Número de mesa</label>
          <input type="text" class="form-control" v-model="actual.t1NumeroMesaIngresado"
                 placeholder="Número de mesa..." :disabled="soloLectura" />
          <small v-if="actual.t1NumeroMesaIngresado && !numeroMesaConfirmado" class="text-danger">
            El número ingresado no coincide con el de la mesa asignada.
          </small>
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">Nombre y Apellido del Observador/a</label>
          <input type="text" class="form-control" v-model="actual.t1ObservadorNombre" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">DNI</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="actual.t1ObservadorDni"
                   placeholder="DNI o documento..." :disabled="soloLectura" />
            <consulta-voluntario v-if="puedeConsultarVoluntario"
                                 :documento="actual.t1ObservadorDni"
                                 :mesa-votacion-id="mesaVotacionId"
                                 :proceso-electoral-id="procesoElectoralId"
                                 :turno="1" />
          </div>
        </div>
      </div>

      <h6 class="font-weight-bold text-dark mb-3 mt-2">REGISTRO DE ASISTENCIA</h6>

      <div class="form-group row mb-0">
        <div class="col-12 col-md-4">
          <label class="mb-1">Hora de ingreso <span class="text-muted">(6 am)</span></label>
          <input type="time" class="form-control" v-model="actual.t1HoraIngreso" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">Hora de salida <span class="text-muted">(1 pm)</span></label>
          <input type="time" class="form-control" v-model="actual.t1HoraSalida" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4 d-flex align-items-end">
          <button type="button" class="btn btn-block font-weight-bold"
                  :class="[actual.t1HoraIngreso ? 'btn-success' : 'btn-primary']"
                  :disabled="soloLectura" @click.prevent="registrarAsistencia()">
            <i v-if="actual.t1HoraIngreso" class="fa fa-check mr-1"></i>
            REGISTRA TU ASISTENCIA
          </button>
        </div>
      </div>

      <div v-if="!cuestionarioHabilitado" class="alert alert-custom alert-light-info mt-4 mb-0">
        <div class="alert-text">
          Completa el nombre del observador, el DNI y el número de mesa, y registra tu hora de ingreso,
          para habilitar el cuestionario.
        </div>
      </div>

      <div v-else-if="!expandirContenido" class="text-center mt-4 pt-3 border-top">
        <a href="#" class="font-weight-bold btn btn-light-primary" @click.prevent="$emit('update:expandirContenido', true)">Ver ficha <i class="fa fa-chevron-down ml-1"></i></a>
      </div>
    </div>

    <div v-show="expandirContenido && mostrarDetalleFicha" class="card-body px-3 px-md-9 py-4 py-md-8">
        <form v-if="cuestionarioHabilitado" class="form" id="frm-mesa-erm-prov-2026-turno-1">
          <q-seccion titulo="SECCIÓN 2 - INICIO DE LA JORNADA ELECTORAL">
            <q-opcion-unica v-model="actual.t1HoraAperturaLocal"
                            label="2.1 ¿A qué hora abrió sus puertas el local de votación?"
                            ayuda="Si marcaste que la mesa &quot;No abrió&quot;, recuerda que puedes actualizar la información durante tu turno." :opciones="opcionesHoraApertura" :solo-lectura="soloLectura"
                            @cambio="limpiarDependientes('t1HoraAperturaLocal')" />

            <q-multiple :valores="actual" label="Si la respuesta fue No abrió, explique el motivo:" :opciones="opcionesMotivoNoAbrio" :aplica="noAbrioLocal" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t1NoAbrioOtroDetalle" label="Otro:" placeholder="Indique el motivo..." :aplica="noAbrioLocal && actual.t1NoAbrioOtro === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t1PermitioIngresoLocal" label="2.2 ¿Se te permitió el ingreso al local de votación?" :solo-lectura="soloLectura" @cambio="cambiarPermisoIngreso" />

            <q-multiple :valores="actual" label="2.3 ¿Qué actores se encuentran en el local de votación?" :opciones="opcionesActores" :aplica="fichaActiva" :solo-lectura="soloLectura"
                        @cambio="asignar" />

            <q-si-no v-model="actual.t1SenializacionAdecuada"
                     label="2.4 ¿La señalización y acondicionamiento del local de votación fue adecuada? (señalización de entrada, salida, croquis de ubicación de mesas)" :aplica="fichaActiva" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t1PersonalOrientador"
                     label="2.5 ¿Hubo personal orientador para los electores por parte de ONPE?" :aplica="fichaActiva" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t1SeInstalaronTodasMesasLocal"
                     label="2.6 ¿Se instalaron todas las mesas del local de votación?"
                     :aplica="fichaActiva" :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t1SeInstalaronTodasMesasLocal')" />

            <q-numero v-model="actual.t1CantidadMesasNoInstaladas"
                      label="Si la respuesta fue NO, indique cuántas mesas no se instalaron:"
                      :aplica="actual.t1SeInstalaronTodasMesasLocal === false" :solo-lectura="soloLectura" />
          </q-seccion>

          <div v-if="!fichaActiva" class="alert alert-custom alert-light-danger">
            <div class="alert-text">
              Registraste que no se te permitió el ingreso al local de votación. No corresponde completar el resto
              de la ficha; comunícate con tu coordinador.
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 3 - ACCESIBILIDAD" :aplica="fichaActiva">
            <q-si-no v-model="actual.t1LocalRampas" label="3.1 ¿El local cuenta con rampas de accesibilidad?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t1LocalBanosAguaPotable"
                     label="3.2 ¿El local cuenta con baños habilitados con agua potable para su uso?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t1LocalMtv" label="3.3 ¿El local cuenta con el Módulo Temporal de Votación (MTV)?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t1LocalZonaSegura"
                     label="3.4 ¿El local cuenta con señalización de zona segura en caso de sismos?" :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 4 - DESARROLLO DE LA JORNADA ELECTORAL" :aplica="fichaActiva">
            <q-matriz-composicion :valores="actual" label="COMPOSICIÓN DE LA MESA DE OBSERVACIÓN" :cargos="cargosMesa" :condiciones="condicionesMesa" :sexos="sexosMesa" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-sub-seccion titulo="INSTALACIÓN DE LA MESA DE OBSERVACIÓN">
              <q-opcion-unica v-model="actual.t1RangoHoraInstalacion"
                              label="4.1 ¿A qué hora se instaló la mesa de sufragio?" :opciones="opcionesRangoInstalacion" :solo-lectura="soloLectura"
                              @cambio="cambiarRangoInstalacion" />

              <q-si-no v-model="actual.t1HechoImpideInstalacion"
                       label="4.2 ¿Se presentó/produjo algún hecho que interrumpa o impida la instalación de la mesa?"
                       incidencia :solo-lectura="soloLectura"
                       @cambio="limpiarDependientes('t1HechoImpideInstalacion')" />

              <q-opcion-unica v-model="actual.t1MotivoImpideInstalacion"
                              label="Si la respuesta fue Si marque una de las opciones:" :opciones="opcionesMotivoImpideInstalacion" :aplica="actual.t1HechoImpideInstalacion === true" :solo-lectura="soloLectura"
                              @cambio="limpiarDependientes('t1MotivoImpideInstalacion')" />

              <q-texto v-model="actual.t1MotivoImpideInstalacionOtroDetalle" label="Otro:"
                       placeholder="Indique el motivo..." :aplica="motivoInstalacionEsOtro" :solo-lectura="soloLectura" />

              <q-si-no v-model="actual.t1PresenciaPersonerosInstalacion"
                       label="4.3 ¿Hay presencia de personeros durante la instalación?" :solo-lectura="soloLectura"
                       @cambio="limpiarDependientes('t1PresenciaPersonerosInstalacion')" />

              <q-texto v-model="actual.t1PresenciaPersonerosInstalacionOrganizacionesTexto"
                       label="Si la respuesta fue SI, indique de qué organizaciones políticas son los personeros presentes:"
                       placeholder="Indique las organizaciones..."
                       :aplica="actual.t1PresenciaPersonerosInstalacion === true" :solo-lectura="soloLectura" />

              <q-si-no v-model="actual.t1CabinasSecretoVoto"
                       label="4.4 ¿La disposición de las cabinas de votación aseguraban el secreto del voto?" :solo-lectura="soloLectura" />
            </q-sub-seccion>
          </q-seccion>

          <q-seccion titulo="SECCIÓN 5 - MATERIALES ELECTORALES EN LA MESA DE VOTACIÓN" :aplica="fichaActiva">
            <q-si-no v-model="actual.t1MaterialElectoralCompleto"
                     label="5.1 ¿Los miembros de mesa recibieron el material electoral completo para la instalación de la mesa?" :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t1MaterialElectoralCompleto')" />

            <q-multiple :valores="actual" label="Si la respuesta fue NO, marque cuál es el material faltante:" :opciones="opcionesMaterialesFaltantes" :aplica="actual.t1MaterialElectoralCompleto === false" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t1FaltaOtrosDetalle" label="Otros:" placeholder="Indique el material..."
                     :aplica="actual.t1MaterialElectoralCompleto === false && actual.t1FaltaOtros === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t1HechoImpideLaborInstalacion"
                     label="5.2 ¿Se presentó/produjo algún hecho que interrumpa o impida el ejercicio de tus funciones como observador/a electoral?"
                     incidencia :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t1HechoImpideLaborInstalacion')" />

            <q-multiple :valores="actual"
                        label="Si la respuesta fue SI, indique el motivo y comunícate con tu coordinador/a:" :opciones="opcionesMotivoLaborInstalacion" :aplica="actual.t1HechoImpideLaborInstalacion === true" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-multiple :valores="actual" label="Desconocimiento de la labor del observador, ¿por parte de quién?" :opciones="opcionesActorLaborInstalacion" :aplica="actual.t1LaborInstalacionDesconocimientoLabor === true" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t1LaborInstalacionOtroDetalle" label="Otro:" placeholder="Indique el motivo..." :aplica="actual.t1LaborInstalacionOtro === true" :solo-lectura="soloLectura" />
          </q-seccion>

          <div v-if="fichaActiva" class="alert alert-custom alert-light-info">
            <div class="alert-text">
              <span class="font-weight-bold">PRIMER CORTE DE INFORMACIÓN - 9:00 A.M.</span>
              Toda la información recogida en la ficha hasta las 9 am deberás subirla a la plataforma.
            </div>
          </div>

          <div v-if="fichaActiva && mesaNoInstalada" class="alert alert-custom alert-light-warning">
            <div class="alert-text">
              Registraste que la mesa no se instaló, por lo que la SECCIÓN 6 no corresponde. Si la mesa se
              instala más tarde, actualiza la pregunta 4.1 y podrás completarla.
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 6 - VOTACIÓN EN LA MESA DE SUFRAGIO" :aplica="seccionVotacionAplica">
            <q-si-no v-model="actual.t1InterrupcionSufragio"
                     label="6.1 ¿Hubo alguna interrupción durante el proceso de sufragio?"
                     incidencia :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t1InterrupcionSufragio')" />

            <q-multiple :valores="actual" label="Si la respuesta es Si, indique el motivo:" :opciones="opcionesMotivoInterrupcion" :aplica="actual.t1InterrupcionSufragio === true" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t1InterrupOtroDetalle" label="Otro:" placeholder="Indique el motivo..." :aplica="actual.t1InterrupOtro === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t1PresenciaPersonerosVotacion"
                     label="6.2 ¿Hay presencia de personeros durante la votación?" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t1HechoImpideLaborSufragio"
                     label="6.3 ¿Se presentó/produjo algún hecho que interrumpa o impida el ejercicio de tus funciones como observador/a electoral?"
                     incidencia :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t1HechoImpideLaborSufragio')" />

            <q-multiple :valores="actual"
                        label="Si la respuesta fue SI, indique el motivo y comunícate con tu coordinador:" :opciones="opcionesMotivoLaborSufragio" :aplica="actual.t1HechoImpideLaborSufragio === true" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-multiple :valores="actual" label="Desconocimiento de la labor del observador, ¿por parte de quién?" :opciones="opcionesActorLaborSufragio" :aplica="actual.t1LaborSufragioDesconocimientoLabor === true" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t1LaborSufragioOtroDetalle" label="Otro:" placeholder="Indique el motivo..." :aplica="actual.t1LaborSufragioOtro === true" :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 7 - ENTORNO DEL LOCAL DE VOTACIÓN" :aplica="fichaActiva">
            <q-si-no v-model="actual.t1PropagandaDentroLocal"
                     label="7.1 ¿Existe propaganda política dentro del local de votación?"
                     :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t1PropagandaDentroLocal')" />

            <q-multiple :valores="actual" label="Si la respuesta fue SI, indique el tipo:"
                        :opciones="opcionesPropDentroLocal" :aplica="actual.t1PropagandaDentroLocal === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t1PropDentroLocalOtraDetalle" label="Otra:" placeholder="Indique el tipo..."
                     :aplica="actual.t1PropDentroLocalOtra === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t1PropagandaFueraLocal"
                     label="7.2 ¿Existe propaganda política fuera del local de votación?"
                     :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t1PropagandaFueraLocal')" />

            <q-multiple :valores="actual" label="Si la respuesta fue SI, indique el tipo:"
                        :opciones="opcionesPropFueraLocal" :aplica="actual.t1PropagandaFueraLocal === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t1PropFueraLocalOtraDetalle" label="Otra:" placeholder="Indique el tipo..."
                     :aplica="actual.t1PropFueraLocalOtra === true" :solo-lectura="soloLectura" />
          </q-seccion>

          <div v-if="fichaActiva" class="alert alert-custom alert-light-info">
            <div class="alert-text">
              <span class="font-weight-bold">SEGUNDO CORTE DE INFORMACIÓN 12:30 PM</span>
              Toda la información recogida en la ficha hasta las 12:30 PM deberás subirla a la plataforma.
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 8 - REGISTRO DE INCIDENCIAS" :aplica="fichaActiva"
                     descripcion="Revisa la cartilla para identificar el tipo de incidencia y reporta el hecho en la plataforma. Describe los hechos de manera breve, identifica actores involucrados e indica la ubicación (interior del local, exterior, mesa de sufragio, ingreso, etc.). No olvides adjuntar la evidencia y reportar la incidencia a tu coordinador.">
            <ficha-incidencias :local-votacion-mesa-proceso-electoral-id="asignacionId || localVotacionMesaProcesoElectoralId"
                               :mesa-votacion-id="mesaVotacionId" :proceso-electoral-id="procesoElectoralId"
                               :turno="1" :solo-lectura="soloLectura" />
          </q-seccion>

          <div class="separator separator-dashed my-6"></div>

          <div class="d-flex justify-content-between align-items-center flex-wrap">
            <div class="text-muted">
              <span v-if="camposPendientes.length"
                    v-b-tooltip.hover.top
                    title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
                <b>{{ camposPendientes.length }}</b> respuestas pendientes
              </span>
              <span v-else class="text-success font-weight-bold">Todas las respuestas obligatorias están completas.</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <span class="label label-lg label-inline mr-3" :class="porcentajeAvance >= 100 ? 'label-light-success' : 'label-light-warning'"
                    v-b-tooltip.hover.top
                    title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
                {{ Number(porcentajeAvance || 0).toFixed(0) }}% completado
              </span>
              <template v-if="!finalizado">
                <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" :disabled="ui.estaGuardando || soloLectura"
                   @click.prevent="guardar(false)">
                  <i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i>
                  Guardar cambios
                </a>
                <button type="button" class="btn btn-sm btn-primary" :disabled="ui.estaGuardando || soloLectura || camposPendientes.length > 0"
                        @click.prevent="finalizar()">Finalizar turno 1</button>
              </template>
              <button v-else-if="puedeReanudarTurno" type="button" class="btn btn-sm btn-warning"
                      :disabled="ui.estaGuardando" @click.prevent="reabrir()">Reabrir turno</button>
            </div>
          </div>
        </form>
    </div>
    </div>
  </div>
</template>

<script>
/**
 * Ficha de observación electoral integral ERM 2026 - Provincias, Turno 1.
 * Literales y numeración del PDF "Ficha PROV Turno 1".
 */
import QSeccion from "../ui/QSeccion";
import QSubSeccion from "../ui/QSubSeccion";
import QSiNo from "../ui/QSiNo";
import QOpcionUnica from "../ui/QOpcionUnica";
import QMultiple from "../ui/QMultiple";
import QTexto from "../ui/QTexto";
import QNumero from "../ui/QNumero";
import QMatrizComposicion from "../ui/QMatrizComposicion";
import FichaIncidencias from "../FichaIncidencias";
import ConsultaVoluntario from "../ui/ConsultaVoluntario";

// Las preguntas de alternativa única y la matriz de composición guardan el texto
// visible, no un código. Se declaran una sola vez para que la herencia se compare
// contra el mismo literal que se muestra y que se persiste.
const HORA_APERTURA = {
  ANTES_6: "Antes de las 6 am",
  DE_601_620: "6:01 am - 6:20am",
  DE_621_640: "6:21 am - 6:40 am",
  DE_641_700: "6:41 am - 7:00 am",
  DESPUES_700: "Después de las 7:00 am",
  NO_ABRIO: "No abrió",
};

const RANGO_INSTALACION = {
  ANTES_7: "Antes de las 7 am",
  DE_7_8: "Entre las 7 am y 8 am",
  DE_801_9: "Entre las 8:01 am y las 9 am",
  DE_901_10: "Entre las 9:01 am y las 10 am",
  DE_1001_12: "Entre las 10:01 am y las 12 m",
  DESPUES_12: "Después de las 12m.",
  NO_SE_INSTALO: "No se instaló",
};

const MOTIVO_INSTALACION = {
  FALTA_MIEMBROS: "Falta de miembros de mesa",
  FALTA_MATERIALES: "Falta de materiales electorales",
  DESCONOCE_MIEMBROS: "Desconocimiento de los miembros de mesa",
  DESCONOCE_ORGANISMOS: "Desconocimiento de los Organismos electorales",
  DESASTRES: "Desastres naturales",
  OTRO: "Otro:",
};

const CONDICION_MESA = {
  TITULAR: "Titular",
  SUPLENTE: "Suplente",
  FILA: "Fila de electores",
  SIN_INFORMACION: "No se brindó información",
};

const SEXO_MESA = { HOMBRE: "Hombre", MUJER: "Mujer" };

// Campo hijo -> pregunta padre. Cuando el padre deja de habilitarlo se limpia,
// porque ocultarlo no basta: seguiría enviándose al servidor.
const DEPENDIENTES = {
  t1HoraAperturaLocal: [
    "t1NoAbrioRetrasoMaterial",
    "t1NoAbrioEventosClimaticos",
    "t1NoAbrioFaltaEnergia",
    "t1NoAbrioOtro",
  ],
  t1NoAbrioOtro: ["t1NoAbrioOtroDetalle"],
  t1SeInstalaronTodasMesasLocal: ["t1CantidadMesasNoInstaladas"],
  t1HechoImpideInstalacion: ["t1MotivoImpideInstalacion"],
  t1MotivoImpideInstalacion: ["t1MotivoImpideInstalacionOtroDetalle"],
  t1PresenciaPersonerosInstalacion: ["t1PresenciaPersonerosInstalacionOrganizacionesTexto"],
  t1MaterialElectoralCompleto: [
    "t1FaltaAnfora",
    "t1FaltaSobresPlasticos",
    "t1FaltaActasElectorales",
    "t1FaltaCartelCandidatos",
    "t1FaltaCabinaVotacion",
    "t1FaltaRelacionElectores",
    "t1FaltaCedulasSufragio",
    "t1FaltaOtros",
  ],
  t1FaltaOtros: ["t1FaltaOtrosDetalle"],
  t1HechoImpideLaborInstalacion: [
    "t1LaborInstalacionDesconocimientoLabor",
    "t1LaborInstalacionRestriccionMovilizarse",
    "t1LaborInstalacionRestriccionObservarMesa",
    "t1LaborInstalacionFaltaRespetoAgresion",
    "t1LaborInstalacionSeparacionInconducta",
    "t1LaborInstalacionOtro",
  ],
  t1LaborInstalacionDesconocimientoLabor: [
    "t1LaborInstalacionActorJne",
    "t1LaborInstalacionActorOnpe",
    "t1LaborInstalacionActorFfaaPnp",
  ],
  t1LaborInstalacionOtro: ["t1LaborInstalacionOtroDetalle"],
  t1InterrupcionSufragio: [
    "t1InterrupAusenciaMiembrosMesa",
    "t1InterrupTrasladoMtv",
    "t1InterrupAltercadoActores",
    "t1InterrupOtro",
  ],
  t1InterrupOtro: ["t1InterrupOtroDetalle"],
  t1HechoImpideLaborSufragio: [
    "t1LaborSufragioDesconocimientoLabor",
    "t1LaborSufragioRestriccionMovilizarse",
    "t1LaborSufragioRestriccionObservarMesa",
    "t1LaborSufragioFaltaRespetoAgresion",
    "t1LaborSufragioSeparacionInconducta",
    "t1LaborSufragioOtro",
  ],
  t1LaborSufragioDesconocimientoLabor: [
    "t1LaborSufragioActorJne",
    "t1LaborSufragioActorOnpe",
    "t1LaborSufragioActorFfaaPnp",
  ],
  t1LaborSufragioOtro: ["t1LaborSufragioOtroDetalle"],
  t1PropagandaDentroLocal: [
    "t1PropDentroLocalBarrasPortatiles",
    "t1PropDentroLocalManifestaciones",
    "t1PropDentroLocalVestimentaIndumentaria",
    "t1PropDentroLocalMaterialGrafico",
    "t1PropDentroLocalOtra",
  ],
  t1PropDentroLocalOtra: ["t1PropDentroLocalOtraDetalle"],
  t1PropagandaFueraLocal: [
    "t1PropFueraLocalBarrasPortatiles",
    "t1PropFueraLocalManifestaciones",
    "t1PropFueraLocalVestimentaIndumentaria",
    "t1PropFueraLocalMaterialGrafico",
    "t1PropFueraLocalVehiculos",
    "t1PropFueraLocalOtra",
  ],
  t1PropFueraLocalOtra: ["t1PropFueraLocalOtraDetalle"],
};

// Preguntas de la SECCIÓN 6, que dejan de aplicar si la mesa no se instaló (4.1).
const CAMPOS_SECCION_VOTACION = [
  "t1InterrupcionSufragio",
  "t1PresenciaPersonerosVotacion",
  "t1HechoImpideLaborSufragio",
];

// Todo lo posterior a la pregunta 2.2: si no se permitió el ingreso, no aplica nada.
const CAMPOS_POSTERIORES_A_INGRESO = [
  "t1ActorOnpe",
  "t1ActorJne",
  "t1ActorFfaaPnp",
  "t1ActorDefensoriaPueblo",
  "t1ActorMinisterioPublico",
  "t1ActorOtrosObservadoresNacionales",
  "t1ActorObservadoresInternacionales",
  "t1ActorSerenazgo",
  "t1SenializacionAdecuada",
  "t1PersonalOrientador",
  "t1SeInstalaronTodasMesasLocal",
  "t1LocalRampas",
  "t1LocalBanosAguaPotable",
  "t1LocalMtv",
  "t1LocalZonaSegura",
  "t1CompPresidenteCondicion",
  "t1CompPresidenteSexo",
  "t1CompSecretarioCondicion",
  "t1CompSecretarioSexo",
  "t1CompTercerMiembroCondicion",
  "t1CompTercerMiembroSexo",
  "t1RangoHoraInstalacion",
  "t1HechoImpideInstalacion",
  "t1PresenciaPersonerosInstalacion",
  "t1CabinasSecretoVoto",
  "t1MaterialElectoralCompleto",
  "t1FaltaOtros",
  "t1HechoImpideLaborInstalacion",
  "t1PropagandaDentroLocal",
  "t1PropagandaFueraLocal",
].concat(CAMPOS_SECCION_VOTACION);

export default {
  name: "Ficha2026ErmProvinciaTurno1",
  components: {
    QSeccion,
    QSubSeccion,
    QSiNo,
    QOpcionUnica,
    QMultiple,
    QTexto,
    QNumero,
    QMatrizComposicion,
    FichaIncidencias,
    ConsultaVoluntario,
  },
  props: {
    // Asignación mesa/proceso/tipo de ficha. Es la clave real de la ficha; llega
    // resuelta en la cabecera. Mesa y proceso viajan solo como respaldo.
    localVotacionMesaProcesoElectoralId: { type: [Number, String], default: null },
    mesaVotacionId: { type: [Number, String], required: true },
    procesoElectoralId: { type: [Number, String], required: true },
    cabecera: { type: Object, default: () => ({}) },
    expandirContenido: { type: Boolean, default: true },
    intervaloAutoGuardado: { type: Number, default: 5000 },
  },
  data() {
    return {
      ui: { estaGuardando: false, estaCargandoDatos: false, tieneCargaInicial: false },
      auth: {},
      porcentajeAvance: 0,
      finalizado: false,
      camposPendientes: [],
      numeroMesaEsperado: "",
      asignacionId: null,
      temporizador: null,
      actual: {
        t1ObservadorNombre: null,
        t1ObservadorDni: null,
        t1NumeroMesaIngresado: null,
        t1HoraIngreso: null,
        t1HoraSalida: null,
        t1HoraAperturaLocal: null,
        t1NoAbrioRetrasoMaterial: null,
        t1NoAbrioEventosClimaticos: null,
        t1NoAbrioFaltaEnergia: null,
        t1NoAbrioOtro: null,
        t1NoAbrioOtroDetalle: null,
        t1PermitioIngresoLocal: null,
        t1ActorOnpe: null,
        t1ActorJne: null,
        t1ActorFfaaPnp: null,
        t1ActorDefensoriaPueblo: null,
        t1ActorMinisterioPublico: null,
        t1ActorOtrosObservadoresNacionales: null,
        t1ActorObservadoresInternacionales: null,
        t1ActorSerenazgo: null,
        t1SenializacionAdecuada: null,
        t1PersonalOrientador: null,
        t1SeInstalaronTodasMesasLocal: null,
        t1CantidadMesasNoInstaladas: null,
        t1LocalRampas: null,
        t1LocalBanosAguaPotable: null,
        t1LocalMtv: null,
        t1LocalZonaSegura: null,
        t1CompPresidenteCondicion: null,
        t1CompPresidenteSexo: null,
        t1CompSecretarioCondicion: null,
        t1CompSecretarioSexo: null,
        t1CompTercerMiembroCondicion: null,
        t1CompTercerMiembroSexo: null,
        t1RangoHoraInstalacion: null,
        t1HechoImpideInstalacion: null,
        t1MotivoImpideInstalacion: null,
        t1MotivoImpideInstalacionOtroDetalle: null,
        t1PresenciaPersonerosInstalacion: null,
        t1PresenciaPersonerosInstalacionOrganizacionesTexto: null,
        t1CabinasSecretoVoto: null,
        t1MaterialElectoralCompleto: null,
        t1FaltaAnfora: null,
        t1FaltaSobresPlasticos: null,
        t1FaltaActasElectorales: null,
        t1FaltaCartelCandidatos: null,
        t1FaltaCabinaVotacion: null,
        t1FaltaRelacionElectores: null,
        t1FaltaCedulasSufragio: null,
        t1FaltaOtros: null,
        t1FaltaOtrosDetalle: null,
        t1HechoImpideLaborInstalacion: null,
        t1LaborInstalacionDesconocimientoLabor: null,
        t1LaborInstalacionRestriccionMovilizarse: null,
        t1LaborInstalacionRestriccionObservarMesa: null,
        t1LaborInstalacionFaltaRespetoAgresion: null,
        t1LaborInstalacionSeparacionInconducta: null,
        t1LaborInstalacionOtro: null,
        t1LaborInstalacionOtroDetalle: null,
        t1LaborInstalacionActorJne: null,
        t1LaborInstalacionActorOnpe: null,
        t1LaborInstalacionActorFfaaPnp: null,
        t1InterrupcionSufragio: null,
        t1InterrupAusenciaMiembrosMesa: null,
        t1InterrupTrasladoMtv: null,
        t1InterrupAltercadoActores: null,
        t1InterrupOtro: null,
        t1InterrupOtroDetalle: null,
        t1PresenciaPersonerosVotacion: null,
        t1HechoImpideLaborSufragio: null,
        t1LaborSufragioDesconocimientoLabor: null,
        t1LaborSufragioRestriccionMovilizarse: null,
        t1LaborSufragioRestriccionObservarMesa: null,
        t1LaborSufragioFaltaRespetoAgresion: null,
        t1LaborSufragioSeparacionInconducta: null,
        t1LaborSufragioOtro: null,
        t1LaborSufragioOtroDetalle: null,
        t1LaborSufragioActorJne: null,
        t1LaborSufragioActorOnpe: null,
        t1LaborSufragioActorFfaaPnp: null,
        t1PropagandaDentroLocal: null,
        t1PropDentroLocalBarrasPortatiles: null,
        t1PropDentroLocalManifestaciones: null,
        t1PropDentroLocalVestimentaIndumentaria: null,
        t1PropDentroLocalMaterialGrafico: null,
        t1PropDentroLocalOtra: null,
        t1PropDentroLocalOtraDetalle: null,
        t1PropagandaFueraLocal: null,
        t1PropFueraLocalBarrasPortatiles: null,
        t1PropFueraLocalManifestaciones: null,
        t1PropFueraLocalVestimentaIndumentaria: null,
        t1PropFueraLocalMaterialGrafico: null,
        t1PropFueraLocalVehiculos: null,
        t1PropFueraLocalOtra: null,
        t1PropFueraLocalOtraDetalle: null,
      },
      guardado: {},
    };
  },
  computed: {
    mostrarDetalleFicha() {
      return this.ui.tieneCargaInicial && (this.auth.autorizadoEdicionTurno || this.finalizado);
    },
    soloLectura() {
      return this.finalizado || !this.auth.autorizadoEdicionTurno;
    },
    puedeReanudarTurno() {
      return this.auth.puedeReanudarTurno === true;
    },
    puedeConsultarVoluntario() {
      return this.auth.puedeConsultarVoluntario === true || this.$session.get("CodigoRol") === "ADM";
    },
    mesaEsperada() {
      return String(this.numeroMesaEsperado || (this.cabecera && this.cabecera.numeroMesa) || "").trim();
    },
    numeroMesaConfirmado() {
      const ingresado = String(this.actual.t1NumeroMesaIngresado || "").trim();
      const esperado = this.mesaEsperada;
      if (!ingresado) return false;
      if (!esperado) return true;
      return ingresado === esperado;
    },
    mesaPendienteDeIdentificar() {
      return !this.mesaEsperada && String(this.actual.t1NumeroMesaIngresado || "").trim() !== "";
    },
    // El DNI se pide tal como llega: puede ser DNI o carné de extranjería.
    cuestionarioHabilitado() {
      return (
        String(this.actual.t1ObservadorNombre || "").trim().length > 0 &&
        String(this.actual.t1ObservadorDni || "").trim().length > 0 &&
        this.numeroMesaConfirmado &&
        String(this.actual.t1HoraIngreso || "").trim().length > 0
      );
    },
    noAbrioLocal() {
      return this.actual.t1HoraAperturaLocal === HORA_APERTURA.NO_ABRIO;
    },
    motivoInstalacionEsOtro() {
      return this.actual.t1MotivoImpideInstalacion === MOTIVO_INSTALACION.OTRO;
    },
    // 2.2 = NO corta la ficha. Sin responder aún, las preguntas siguen visibles.
    fichaActiva() {
      return this.actual.t1PermitioIngresoLocal !== false;
    },
    mesaNoInstalada() {
      return this.actual.t1RangoHoraInstalacion === RANGO_INSTALACION.NO_SE_INSTALO;
    },
    seccionVotacionAplica() {
      return this.fichaActiva && !this.mesaNoInstalada;
    },
    opcionesHoraApertura() {
      return [
        { valor: HORA_APERTURA.ANTES_6, etiqueta: HORA_APERTURA.ANTES_6 },
        { valor: HORA_APERTURA.DE_601_620, etiqueta: HORA_APERTURA.DE_601_620 },
        { valor: HORA_APERTURA.DE_621_640, etiqueta: HORA_APERTURA.DE_621_640 },
        { valor: HORA_APERTURA.DE_641_700, etiqueta: HORA_APERTURA.DE_641_700 },
        { valor: HORA_APERTURA.DESPUES_700, etiqueta: HORA_APERTURA.DESPUES_700 },
        { valor: HORA_APERTURA.NO_ABRIO, etiqueta: HORA_APERTURA.NO_ABRIO },
      ];
    },
    opcionesMotivoNoAbrio() {
      return [
        { campo: "t1NoAbrioRetrasoMaterial", etiqueta: "Retraso en la llegada del material" },
        { campo: "t1NoAbrioEventosClimaticos", etiqueta: "Eventos climáticos" },
        { campo: "t1NoAbrioFaltaEnergia", etiqueta: "Falta de energía eléctrica" },
        { campo: "t1NoAbrioOtro", etiqueta: "Otro:" },
      ];
    },
    opcionesActores() {
      return [
        { campo: "t1ActorOnpe", etiqueta: "Personal de la ONPE" },
        { campo: "t1ActorJne", etiqueta: "Personal del JNE" },
        { campo: "t1ActorFfaaPnp", etiqueta: "FFAA/ PNP" },
        { campo: "t1ActorDefensoriaPueblo", etiqueta: "Defensoria del Pueblo" },
        { campo: "t1ActorMinisterioPublico", etiqueta: "Ministerio Público" },
        { campo: "t1ActorOtrosObservadoresNacionales", etiqueta: "Otros observadores nacionales" },
        { campo: "t1ActorObservadoresInternacionales", etiqueta: "Observadores internacionales" },
        { campo: "t1ActorSerenazgo", etiqueta: "Serenazgo" },
      ];
    },
    cargosMesa() {
      return [
        { etiqueta: "PRESIDENTE", campoCondicion: "t1CompPresidenteCondicion", campoSexo: "t1CompPresidenteSexo" },
        { etiqueta: "SECRETARIO", campoCondicion: "t1CompSecretarioCondicion", campoSexo: "t1CompSecretarioSexo" },
        { etiqueta: "TERCER MIEMBRO", campoCondicion: "t1CompTercerMiembroCondicion", campoSexo: "t1CompTercerMiembroSexo" },
      ];
    },
    condicionesMesa() {
      return [
        { valor: CONDICION_MESA.TITULAR, etiqueta: CONDICION_MESA.TITULAR },
        { valor: CONDICION_MESA.SUPLENTE, etiqueta: CONDICION_MESA.SUPLENTE },
        { valor: CONDICION_MESA.FILA, etiqueta: CONDICION_MESA.FILA },
        { valor: CONDICION_MESA.SIN_INFORMACION, etiqueta: CONDICION_MESA.SIN_INFORMACION },
      ];
    },
    sexosMesa() {
      return [
        { valor: SEXO_MESA.HOMBRE, etiqueta: SEXO_MESA.HOMBRE },
        { valor: SEXO_MESA.MUJER, etiqueta: SEXO_MESA.MUJER },
      ];
    },
    opcionesRangoInstalacion() {
      return [
        { valor: RANGO_INSTALACION.ANTES_7, etiqueta: RANGO_INSTALACION.ANTES_7 },
        { valor: RANGO_INSTALACION.DE_7_8, etiqueta: RANGO_INSTALACION.DE_7_8 },
        { valor: RANGO_INSTALACION.DE_801_9, etiqueta: RANGO_INSTALACION.DE_801_9 },
        { valor: RANGO_INSTALACION.DE_901_10, etiqueta: RANGO_INSTALACION.DE_901_10 },
        { valor: RANGO_INSTALACION.DE_1001_12, etiqueta: RANGO_INSTALACION.DE_1001_12 },
        { valor: RANGO_INSTALACION.DESPUES_12, etiqueta: RANGO_INSTALACION.DESPUES_12 },
        { valor: RANGO_INSTALACION.NO_SE_INSTALO, etiqueta: RANGO_INSTALACION.NO_SE_INSTALO },
      ];
    },
    opcionesMotivoImpideInstalacion() {
      return [
        { valor: MOTIVO_INSTALACION.FALTA_MIEMBROS, etiqueta: MOTIVO_INSTALACION.FALTA_MIEMBROS },
        { valor: MOTIVO_INSTALACION.FALTA_MATERIALES, etiqueta: MOTIVO_INSTALACION.FALTA_MATERIALES },
        { valor: MOTIVO_INSTALACION.DESCONOCE_MIEMBROS, etiqueta: MOTIVO_INSTALACION.DESCONOCE_MIEMBROS },
        { valor: MOTIVO_INSTALACION.DESCONOCE_ORGANISMOS, etiqueta: MOTIVO_INSTALACION.DESCONOCE_ORGANISMOS },
        { valor: MOTIVO_INSTALACION.DESASTRES, etiqueta: MOTIVO_INSTALACION.DESASTRES },
        { valor: MOTIVO_INSTALACION.OTRO, etiqueta: MOTIVO_INSTALACION.OTRO },
      ];
    },
    opcionesMaterialesFaltantes() {
      return [
        { campo: "t1FaltaAnfora", etiqueta: "Ánfora" },
        { campo: "t1FaltaSobresPlasticos", etiqueta: "Sobres plásticos de colores" },
        { campo: "t1FaltaActasElectorales", etiqueta: "Actas electorales" },
        { campo: "t1FaltaCartelCandidatos", etiqueta: "Cartel de candidatos" },
        { campo: "t1FaltaCabinaVotacion", etiqueta: "Cabina de votación" },
        { campo: "t1FaltaRelacionElectores", etiqueta: "Relación de electores" },
        { campo: "t1FaltaCedulasSufragio", etiqueta: "Cédulas de sufragio" },
        { campo: "t1FaltaOtros", etiqueta: "Otros:" },
      ];
    },
    opcionesMotivoLaborInstalacion() {
      return [
        { campo: "t1LaborInstalacionDesconocimientoLabor", etiqueta: "Desconocimiento de la labor del observador" },
        { campo: "t1LaborInstalacionRestriccionMovilizarse", etiqueta: "Restricción para movilizarse dentro del local de votación" },
        { campo: "t1LaborInstalacionRestriccionObservarMesa", etiqueta: "Restricción para observar la mesa de votación" },
        { campo: "t1LaborInstalacionFaltaRespetoAgresion", etiqueta: "Falta de respeto, agresión contra el observador" },
        { campo: "t1LaborInstalacionSeparacionInconducta", etiqueta: "Separación del observador por inconducta o faltas a la normativa electoral" },
        { campo: "t1LaborInstalacionOtro", etiqueta: "Otro" },
      ];
    },
    opcionesActorLaborInstalacion() {
      return [
        { campo: "t1LaborInstalacionActorJne", etiqueta: "JNE" },
        { campo: "t1LaborInstalacionActorOnpe", etiqueta: "ONPE" },
        { campo: "t1LaborInstalacionActorFfaaPnp", etiqueta: "FFAA/PNP" },
      ];
    },
    opcionesMotivoInterrupcion() {
      return [
        { campo: "t1InterrupAusenciaMiembrosMesa", etiqueta: "Ausencia de miembros de mesa" },
        { campo: "t1InterrupTrasladoMtv", etiqueta: "Traslado de los miembros de mesa al Módulo Temporal de Votación" },
        { campo: "t1InterrupAltercadoActores", etiqueta: "Altercado entre actores electorales (personeros, JNE, ONPE, etc)" },
        { campo: "t1InterrupOtro", etiqueta: "Otro:" },
      ];
    },
    opcionesMotivoLaborSufragio() {
      return [
        { campo: "t1LaborSufragioDesconocimientoLabor", etiqueta: "Desconocimiento de la labor del observador" },
        { campo: "t1LaborSufragioRestriccionMovilizarse", etiqueta: "Restricción para movilizarse dentro del local de votación" },
        { campo: "t1LaborSufragioRestriccionObservarMesa", etiqueta: "Restricción para observar la mesa de votación" },
        { campo: "t1LaborSufragioFaltaRespetoAgresion", etiqueta: "Falta de respeto, agresión contra el observador" },
        { campo: "t1LaborSufragioSeparacionInconducta", etiqueta: "Separación del observador por inconducta o faltas a la normativa electoral" },
        { campo: "t1LaborSufragioOtro", etiqueta: "Otro" },
      ];
    },
    opcionesActorLaborSufragio() {
      return [
        { campo: "t1LaborSufragioActorJne", etiqueta: "JNE" },
        { campo: "t1LaborSufragioActorOnpe", etiqueta: "ONPE" },
        { campo: "t1LaborSufragioActorFfaaPnp", etiqueta: "FFAA/PNP" },
      ];
    },
    opcionesPropDentroLocal() {
      return [
        { campo: "t1PropDentroLocalBarrasPortatiles", etiqueta: "Barras / Portátiles" },
        { campo: "t1PropDentroLocalManifestaciones", etiqueta: "Manifestaciones" },
        { campo: "t1PropDentroLocalVestimentaIndumentaria", etiqueta: "Vestimenta o indumentaria" },
        { campo: "t1PropDentroLocalMaterialGrafico", etiqueta: "Material grafico" },
        { campo: "t1PropDentroLocalOtra", etiqueta: "Otra:" },
      ];
    },
    opcionesPropFueraLocal() {
      return [
        { campo: "t1PropFueraLocalBarrasPortatiles", etiqueta: "Barras / Portátiles" },
        { campo: "t1PropFueraLocalManifestaciones", etiqueta: "Manifestaciones" },
        { campo: "t1PropFueraLocalVestimentaIndumentaria", etiqueta: "Vestimenta o indumentaria" },
        { campo: "t1PropFueraLocalMaterialGrafico", etiqueta: "Material grafico" },
        { campo: "t1PropFueraLocalVehiculos", etiqueta: "Vehículos" },
        { campo: "t1PropFueraLocalOtra", etiqueta: "Otra:" },
      ];
    },
    isDirty() {
      return JSON.stringify(this.actual) !== JSON.stringify(this.guardado);
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos || this.soloLectura) return;
        this.programarAutoGuardado();
      },
    },
  },
  mounted() {
    this.cargar();
  },
  beforeDestroy() {
    if (this.temporizador) clearTimeout(this.temporizador);
  },
  methods: {
    /**
     * Escribe un campo del modelo (usado por los controles de opción múltiple y
     * por la matriz de composición). Al desmarcar una opción también se limpia lo
     * que dependía de ella: "Otro" y el actor de "Desconocimiento de la labor".
     */
    asignar(evento) {
      this.$set(this.actual, evento.campo, evento.valor);
      if (evento.valor !== true) this.limpiarDependientes(evento.campo);
    },

    /** Limpia en cascada los campos que dependen de la pregunta indicada. */
    limpiarDependientes(campo) {
      const hijos = DEPENDIENTES[campo];
      if (!hijos) return;
      this.limpiarCampos(hijos);
    },

    limpiarCampos(campos) {
      campos.forEach((campo) => {
        if (this.actual[campo] !== null && this.actual[campo] !== undefined) {
          this.$set(this.actual, campo, null);
        }
        this.limpiarDependientes(campo);
      });
    },

    hayDatosEn(campos) {
      return campos.some((campo) => {
        const v = this.actual[campo];
        return v !== null && v !== undefined && v !== "";
      });
    },

    /**
     * Si el cambio deja sin sentido un bloque ya llenado, pide confirmación y
     * revierte el valor si el observador cancela. QSiNo / QOpcionUnica ya
     * escribieron el nuevo valor vía v-model antes de emitir `cambio`.
     */
    confirmarLimpieza(campos, mensaje, revertir) {
      if (!this.hayDatosEn(campos)) {
        this.limpiarCampos(campos);
        return;
      }
      this.$bvModal
        .msgBoxConfirm(mensaje, {
          title: "Confirmar cambio",
          okTitle: "Sí, borrar y continuar",
          cancelTitle: "Cancelar",
          okVariant: "danger",
          centered: true,
        })
        .then((confirmado) => {
          if (confirmado) this.limpiarCampos(campos);
          else if (typeof revertir === "function") revertir();
        });
    },

    /** 2.2 = NO detiene la ficha: nada posterior aplica ni debe conservar valor. */
    cambiarPermisoIngreso(valor) {
      if (valor !== false) return;
      this.confirmarLimpieza(
        CAMPOS_POSTERIORES_A_INGRESO,
        "Se borrarán las respuestas posteriores a esta pregunta. ¿Deseas continuar?",
        () => this.$set(this.actual, "t1PermitioIngresoLocal", true)
      );
    },

    /** 4.1 = "No se instaló" deja sin sentido la votación en la mesa (SECCIÓN 6). */
    cambiarRangoInstalacion(valor) {
      if (valor !== RANGO_INSTALACION.NO_SE_INSTALO) {
        this._ultimoRangoInstalacion = valor;
        return;
      }
      const previo = this._ultimoRangoInstalacion;
      this.confirmarLimpieza(
        CAMPOS_SECCION_VOTACION,
        "Se borrarán las respuestas de la sección de votación. ¿Deseas continuar?",
        () => this.$set(this.actual, "t1RangoHoraInstalacion", previo || null)
      );
    },

    registrarAsistencia() {
      if (this.soloLectura || this.actual.t1HoraIngreso) return;
      const ahora = new Date();
      const hh = String(ahora.getHours()).padStart(2, "0");
      const mm = String(ahora.getMinutes()).padStart(2, "0");
      this.$set(this.actual, "t1HoraIngreso", hh + ":" + mm);
    },

    programarAutoGuardado() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (this.temporizador) clearTimeout(this.temporizador);
      this.temporizador = setTimeout(() => this.guardar(true), this.intervaloAutoGuardado);
    },

    identificacion() {
      return {
        localVotacionMesaProcesoElectoralId: this.asignacionId || this.localVotacionMesaProcesoElectoralId,
        mesaVotacionId: this.mesaVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };
    },

    /**
     * Merge a 3 vías heredado de las fichas 2022 / 2026 mesa.
     * Si el observador no tocó el campo desde el último guardado conocido, se
     * acepta el valor del servidor; si lo tocó, se conserva lo local. Evita
     * que un autoguardado pise lo que se escribió mientras viajaba la petición.
     */
    actualizarBaseDiferente(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      const vActual = JSON.stringify(fichaActual[propiedad]);
      const vGuardado = JSON.stringify(fichaGuardado[propiedad]);
      const vActualizado = JSON.stringify(fichaActualizada[propiedad]);
      return vActual === vGuardado && vGuardado !== vActualizado
        ? fichaActualizada[propiedad]
        : fichaActual[propiedad];
    },

    aHoraCorta(valor) {
      const texto = String(valor || "").trim();
      return texto.length >= 5 ? texto.substring(0, 5) : null;
    },

    normalizarFichaServidor(ficha) {
      const normalizada = this.cloneObject(ficha || {});
      if (Object.prototype.hasOwnProperty.call(normalizada, "t1HoraIngreso")) {
        normalizada.t1HoraIngreso = this.aHoraCorta(normalizada.t1HoraIngreso);
      }
      if (Object.prototype.hasOwnProperty.call(normalizada, "t1HoraSalida")) {
        normalizada.t1HoraSalida = this.aHoraCorta(normalizada.t1HoraSalida);
      }
      return normalizada;
    },

    aplicarMeta(d) {
      this.auth = d.auth || {};
      this.porcentajeAvance = d.porcentajeAvanceTurnoActual || 0;
      this.finalizado = d.tieneRegistroFinalizadoTurnoActual === true;
      this.camposPendientes = d.camposPendientes || [];
      this.numeroMesaEsperado = d.numeroMesaEsperado || "";
      if (d.localVotacionMesaProcesoElectoralId) {
        this.asignacionId = d.localVotacionMesaProcesoElectoralId;
        this.$emit("guardado", d);
      }
    },

    aplicarFicha(fichaServidor) {
      const ficha = this.normalizarFichaServidor(fichaServidor);

      if (!this.ui.tieneCargaInicial) {
        Object.keys(this.actual).forEach((campo) => {
          if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
            this.actual[campo] = ficha[campo];
          }
        });
        this.guardado = this.cloneObject(this.actual);
        this._ultimoRangoInstalacion = this.actual.t1RangoHoraInstalacion;
        return;
      }

      const tempActual = this.cloneObject(this.actual);
      const tempGuardado = this.cloneObject(this.guardado);
      Object.keys(tempActual).forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
          tempActual[campo] = this.actualizarBaseDiferente(campo, tempActual, tempGuardado, ficha);
        }
      });
      this.actual = this.cloneObject(tempActual);

      // guardado = último estado confirmado del servidor. Lo que el observador
      // siguió escribiendo durante la petición queda sucio y dispara otro autoguardado.
      const nuevoGuardado = this.cloneObject(this.guardado);
      Object.keys(this.actual).forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
          nuevoGuardado[campo] = ficha[campo];
        }
      });
      this.guardado = nuevoGuardado;
    },

    async cargar() {
      this.ui.estaCargandoDatos = true;
      await this.$http
        .post(this.apiRoute("Ficha2026ErmProvincia", "GetTurnoUno"), this.identificacion())
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) return;
          const d = response.body.data || {};
          this.aplicarMeta(d);
          this.aplicarFicha(d.ficha);
        }, this.mostrarMensajeExcepcionVueResource);
      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
      this.$emit("cargado");
      if (this.isDirty && !this.soloLectura) this.programarAutoGuardado();
    },

    /**
     * El payload es el modelo `actual` tal cual, más la identificación.
     * Newtonsoft es case-insensitive: `t1ObservadorNombre` enlaza con
     * `T1ObservadorNombre`. No se renombra. En provincia las organizaciones
     * se escriben a mano; el campo de ParamIds no se usa.
     */
    armarRequest() {
      const modelo = this.cloneObject(this.actual);
      Object.assign(modelo, this.identificacion());
      modelo.t1PresenciaPersonerosInstalacionOrganizacionParamIds = null;
      return modelo;
    },

    async confirmarIdentificacionMesa(silencioso) {
      if (!this.mesaPendienteDeIdentificar) return true;
      if (silencioso) return false;
      const numero = String(this.actual.t1NumeroMesaIngresado || "").trim();
      const confirmado = await this.$bvModal.msgBoxConfirm(
        "Vas a registrar la mesa N° " + numero + ". Después no podrás cambiar este número. Asegúrate de incluir todos los ceros del inicio.",
        {
          title: "Confirmar número de mesa",
          okTitle: "Registrar mesa " + numero,
          cancelTitle: "Revisar",
        }
      );
      return confirmado === true;
    },

    async guardar(silencioso) {
      if (this.ui.estaGuardando || this.soloLectura || this.ui.estaCargandoDatos) return false;
      if (!this.cuestionarioHabilitado) {
        if (!silencioso) {
          this.$bvToast.toast(
            "Completa el nombre del observador, el DNI, el número de mesa y la hora de ingreso antes de guardar.",
            { title: "Turno 1", autoHideDelay: 5000, variant: "warning", solid: true }
          );
        }
        return false;
      }
      if (!(await this.confirmarIdentificacionMesa(silencioso))) return false;
      if (silencioso && !this.isDirty) return false;

      const actualClone = this.cloneObject(this.actual);
      const modelo = this.armarRequest();

      this.ui.estaGuardando = true;
      let exitoso = false;
      await this.$http
        .post(this.apiRoute("Ficha2026ErmProvincia", "EditTurnoUno"), modelo)
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) return;
          this.guardado = actualClone;
          exitoso = true;
          this.$emit("guardado", response.body.data);
          if (!silencioso) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 1",
              autoHideDelay: 5000,
              variant: "success",
              solid: true,
            });
          }
        }, this.mostrarMensajeExcepcionVueResource);
      this.ui.estaGuardando = false;

      if (exitoso) await this.cargar();
      return exitoso;
    },

    finalizar() {
      this.$bvModal
        .msgBoxConfirm("¿Confirma que desea finalizar el Turno 1? Después no podrá editarlo.", {
          title: "Finalizar turno",
          okTitle: "Finalizar",
          cancelTitle: "Cancelar",
        })
        .then(async (confirmado) => {
          if (!confirmado) return;
          if (this.isDirty) {
            const guardado = await this.guardar(!this.mesaPendienteDeIdentificar);
            if (!guardado) return;
          }
          this.$http
            .post(this.apiRoute("Ficha2026ErmProvincia", "FinalizarTurno"),
              Object.assign({ turno: 1 }, this.identificacion()))
            .then(function (response) {
              if (this.procesarRespuestaErrorDefecto(response)) {
                const d = response.body.data || {};
                if (d.camposPendientes) this.camposPendientes = d.camposPendientes;
                return;
              }
              this.finalizado = true;
              this.$emit("finalizado", response.body.data);
              this.$bvToast.toast(response.body.message || "Turno finalizado.", {
                title: "Turno 1",
                autoHideDelay: 5000,
                variant: "success",
                solid: true,
              });
            }, this.mostrarMensajeExcepcionVueResource);
        });
    },

    reabrir() {
      this.$bvModal
        .msgBoxConfirm("¿Confirma que desea reabrir el Turno 1? Volverá a ser editable.", {
          title: "Reabrir turno",
          okTitle: "Reabrir",
          cancelTitle: "Cancelar",
        })
        .then((confirmado) => {
          if (!confirmado) return;
          this.ui.estaGuardando = true;
          this.$http
            .post(this.apiRoute("Ficha2026ErmProvincia", "RevertirTurno"),
              Object.assign({ turno: 1 }, this.identificacion()))
            .then(function (response) {
              this.ui.estaGuardando = false;
              if (this.procesarRespuestaErrorDefecto(response)) return;
              this.aplicarMeta(response.body.data || {});
              this.$emit("finalizado", response.body.data);
              this.$bvToast.toast(response.body.message || "Turno reabierto.", {
                title: "Turno 1",
                autoHideDelay: 5000,
                variant: "success",
                solid: true,
              });
            }, function (error) {
              this.ui.estaGuardando = false;
              this.mostrarMensajeExcepcionVueResource(error);
            });
        });
    },
  },
};
</script>
